export const gradebookText = {
  title: 'Results',
  learner: 'Learner',
  courseGrade: 'Course Score',
  finished: 'Completed',
  accepted: 'Accepted',
};
